import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppConfigService } from '../app-config.service';
import { TestAutomatiseCapacite } from './test-automatise-capacite';
import { TestAutomatisePreautorisation } from './test-automatise-preautorisation';

declare global {
  interface Window {
    TestHelper: TestAutomatiseHelperService | null;
    Cypress: unknown;
  }
}

/**
 * Cette classe rend disponible une interface pour aider les tests automatisés
 * lorsque l'application est exécutée dans un contexte Cypress
 */
@Injectable({
  providedIn: 'root'
})
export class TestAutomatiseHelperService {
  capacite: TestAutomatiseCapacite;
  preautorisation: TestAutomatisePreautorisation;

  constructor(store: Store, appConfig: AppConfigService) {
    if (window.Cypress) {
      window.TestHelper = this;
      this.capacite = new TestAutomatiseCapacite(store);
      this.preautorisation = new TestAutomatisePreautorisation(store, appConfig);
    }
  }
}
